const localidadInitialState = {
  localidad: {
    loading: false,
    error: null,
    data: null,
  },
};

export default localidadInitialState;
